import * as ReturnCodesConstants from '../../../../../constants/ReturnCodesConstants'
import * as RoutePathConstants from '../../../../../constants/RoutePathConstants'
import {mapActions, mapState} from 'vuex'
// import dateUtils from '../../../../common/utils/dateUtil'
import moment from 'moment'
import wx from 'weixin-js-sdk'
import memberApi from '../../../../../api/wx-member/member/member'
import * as types from '../../../member/store/mutations-types'

export default {
  data () {
    return {
      flag: false,
      productDetailsList: [],
      id: '',
      centerHeight: document.documentElement.clientHeight - 260 + 'px',
      montyTotal: 0
    }
  },
  computed: {
    ...mapState('paymentDetailsModule', []),
  },
  methods: {
    ...mapActions('paymentDetailsModule', ['purchaseOrder']),
    dateFormat (time) {
      return time ? moment(time).format('YYYY/MM/DD') : ''
    },
    async purchase () {
      this.flag = true
      let list = []
      this.returnData.filter(item => {
        list.push({id: item.id})
      })
      let prepayResponse = await this.purchaseOrder(list)
      //微信支付
      if (prepayResponse.code === ReturnCodesConstants.SUCCESS_CODE) {
        if (this.productDetailsList[0].paymentMethod === 3000) {
          const chooseWXPayMap = prepayResponse.data.prepayResponseInfo.chooseWXPayMap
          if (!chooseWXPayMap) {
            this.$message.error('预支付参数有问题')
            return
          }
          const result = await memberApi.getWXSignature({url: location.href.split('#')[0]})
          const vm = this
          wx.config({
            debug: false,
            appId: result.appId, // 必填,公众号的唯一标识
            timestamp: result.timestamp, // 必填,生成签名的时间戳
            nonceStr: result.nonceStr, // 必填,生成签名的随机串
            signature: result.signature, // 必填,签名
            jsApiList: ['checkJsApi', 'chooseWXPay'] // 必填,需要使用的JS接口列表
          })
          wx.ready(() => {
            wx.checkJsApi({
              jsApiList: ['chooseWXPay'],
              success: function (res) {
                wx.chooseWXPay({
                  appId: result.appId,
                  timestamp: chooseWXPayMap.timeStamp,
                  nonceStr: chooseWXPayMap.nonceStr,
                  package: chooseWXPayMap.package,
                  signType: chooseWXPayMap.signType,
                  paySign: chooseWXPayMap.paySign,
                  success: function (res) {
                    if (res.errMsg === 'chooseWXPay:ok') {
                      vm.$router.push({
                        path: RoutePathConstants.POINTS_MAIL_CASHIER,
                        query: {
                          payOrderNum: prepayResponse.data.payOrderNum
                        }
                      })
                      return
                    }
                    vm.$message.error('支付失败', res.errMsg)
                  },
                  cancel: function (res) {
                    console.log('取消支付', res)
                    vm.$message.error('取消支付')
                  },
                  fail: function (res) {
                    console.log('支付失败', res)
                    vm.$message.error('支付失败')
                  }
                })
              },
              fail: function (res) {
                alert('fail' + res)
              }
            })
          })
          /* 处理失败验证 */
          wx.error(function (res) {
            // config 信息验证失败会执行error函数,如签名过期导致验证失败,
            // 具体错误信息可以打开config的debug模式查看,也可以在返回的res参数中查看,对于SPA可以在这里更新签名
            alert('配置验证失败: ' + res.errMsg)
          })
        } else {
          this.$router.push({
            path: RoutePathConstants.POINTS_MAIL_CASHIER,
            query: {
              payOrderNum: prepayResponse.data.payOrderNum
            }
          })
        }
      } else {
        this.$message.error(prepayResponse.data.message)
      }
    }
  },
  mounted () {
    this.returnData = JSON.parse(this.$route.query.returnData)
    this.productDetailsList = JSON.parse(this.$route.query.data).filter(item => {
      if (!item.payNum) {
        item.payNum = 1
      }
      if (item.paymentMethod === 1000) {
        this.montyTotal += item.commodityStoredValueCard * 1 * item.commodityQty
      } else if (item.paymentMethod === 2000) {
        this.montyTotal += item.commodityPoints * 1 * item.commodityQty
      } else if (item.paymentMethod === 3000) {
        this.montyTotal += item.commodityCash * 1 * item.commodityQty
      }
      return item
    })
    if (this.productDetailsList[0].paymentMethod === 1000) {
      this.montyTotal = '立即兑换  ' + this.montyTotal + '储值金'
    } else if (this.productDetailsList[0].paymentMethod === 2000) {
      this.montyTotal = '立即兑换  ' + this.montyTotal + '积分'
    } else if (this.productDetailsList[0].paymentMethod === 3000) {
      this.montyTotal = '立即购买  ' + this.montyTotal + '元'
    }
  }
}



// WEBPACK FOOTER //
// ./src/pages/wx-member/points-mall/payment-details/views/payment-details.js